import * as actionTypes from '../actions/actionsTypes'

const initialState = {
    token:null,
    userid:null,
    isFirst:null,
    email:null,
    username:null,
    error:null,
    loading:false,
    authRedirectPath:'/'
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_START :
            return {
                ...state,
                error:null,
                loading:true
            }
        case actionTypes.AUTH_SUCCESS:
            return {
                ...state,
                userid:action.userid,
                token:action.token,
                email:action.email,
                isFirst:action.isFirst,
                username:action.username,
                error:null,
                loading:false
            }
        case actionTypes.AUTH_FAIL:
            return {
                ...state,
                error:action.error,
                loading:false
            }
        case actionTypes.AUTH_LOGOUT:
            return {
                ...state,
                token:null,
                isFirst:null,
                userid:null,
                email:null,
                username:null
            }
        case actionTypes.SET_AUTH_REDIRECT_PATH:
            return {
                ...state,
                authRedirectPath:action.path
            }
        
        default : return state;
    }
}

export default reducer;